import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Footer.scss';
import Banner from '../../Images/Banner.png'
import AreaData from '../../Components/ServicesPage/AreaData'

export default function Footer({ CitiePhone, locationsMain }) {
    const Navigate = useNavigate()
    return (
        <div className="Footer">
            <div className="FooterTop">
                <h1>ALSO OF INTEREST:</h1>
                <a href="/">Home Page</a>
                <a href="/airduct">Air Duct Cleaning</a>
                <a href="/dryer">Dryer Vent Cleaning</a>
                <a href="/chimney">Chimney and Fireplace</a>
                <a href="/roofing">Roofing</a>
                <a href="/hvac">HVAC Air Conditioning and Heating</a>
                <a href="/services">All Services</a>
                <a href="/sitemap">Site Map</a>
            </div>
            <div className="FooterTopMidd">
                <img src={require(`../../ImagesLogos/logobanner2.png`)} />
                <h1>ROCKET AIR CARE</h1>
            </div>
            <div className="FooterTopServices">
                <h1>OUR SERVICES</h1>
                <div className="FooterTopServicesList">
                    {AreaData.map((A, index) =>
                        <a key={index} href={A.Path}>{A.Title}</a>
                    )}
                </div>
            </div>
            <div className="FooterBottom">
                <div className="FooterBottomLeft">
                    <p>The term "allergens" as used on this website pertains exclusively to inanimate dust-mite matter, non-living matter, or allergens from non-living sources. Rocket Air Care serves to remove these contaminants to provide a cleaner & healthier home.</p>
                    <p>Copyright © 2001- 2024 Rocket Air Care LLC. All Rights Reserved. All Rocket Air Care. Available Services, Pricing, Promotions, and Hours of Operation may vary by location.</p>
                    <h3>Rocket Air Care LLC</h3>
                    <div className="FooterBottompri">
                        <a href="/privacy-policy">Privacy Policy</a>
                        <a href="/terms-and-conditions">Terms And Conditions</a>
                        <a href="/sitemap">Site Map</a>
                    </div>
                </div>
                <div className="FooterBottomRight">
                    <h1>CONNECT WITH US</h1>
                    <p>Phone: <a href={`tel:${CitiePhone}`}>{CitiePhone}</a></p>
                    <p>info@rocketaircare.com</p>
                    <p>www.rocketaircare.com</p>
                </div>
            </div>
        </div>
    )
}
